import React from 'react';
import './get-premium-pass.less';
import { useClassName, useWindowSize } from 'common/hooks';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Button } from 'common/lazy';

export const GetPremiumPass = ({ enhanceVisitCard }) => {
  const { isMobile, isTablet } = useWindowSize();
  const className = useClassName('GetPremiumPass');
  console.log(
    'enhanceVisitCard.background.mobile',
    enhanceVisitCard.background
  );
  const backgroundImage = isMobile
    ? enhanceVisitCard.background.mobile.source.assetUrl
    : isTablet
    ? enhanceVisitCard.background.tablet.source.assetUrl
    : enhanceVisitCard.background.desktop.source.assetUrl;
  const backgroundSize = isMobile
    ? enhanceVisitCard.background.mobile.size
    : isTablet
    ? enhanceVisitCard.background.tablet.size
    : enhanceVisitCard.background.desktop.size;

  // Calcular el aspect ratio para mantener las proporciones
  const aspectRatio = (backgroundSize.height / backgroundSize.width) * 100;

  return (
    <div className={className('container')}>
      {/* <div className={className('pet')}>
        <img src={enhanceVisitCard.petImage.url} alt="" />
      </div> */}
      <div
        className={className('wrapper')}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          paddingBottom: `${aspectRatio}%`,
        }}>
        <div className={className('inner')}>
          <div className={className('info')}>
            <div className={className('info__logo')}>
              <img src={enhanceVisitCard.logoImage.url} alt="" />
            </div>
            <div className={className('info__description')}>
              {documentToReactComponents(enhanceVisitCard.description)}
            </div>
            <Button
              className={className('info__cta')}
              primary
              content={enhanceVisitCard.link.label}
              href={enhanceVisitCard.link.url}
              target={
                enhanceVisitCard.link.type === 'external' ? '_blank' : '_self'
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
